module.exports = __webpack_public_path__ + "media/images/pc/brands/sola/store_sapporo-de000f55a99439fd43ecda6035180e7d.webp";